import { OppvarmingVarmepumpe } from '../../../../../../../types/registration/userInput';
import { JaNeiVetIkke, OppvarmingBruk, Termostatstyring } from '../../../../../utils/registerEnums';

export enum VarmepumpeFordeling {
  Punktoppvarming = 'punktoppvarming',
  VannbarenVarme = 'vannbarenVarme',
  Ventilasjon = 'ventilasjon'
}

export const deriveFordelingRadioValue = (value?: OppvarmingVarmepumpe) => {
  if (value?.punktoppvarming) {
    return VarmepumpeFordeling.Punktoppvarming;
  }
  if (value?.vannbarenVarme) {
    return VarmepumpeFordeling.VannbarenVarme;
  }
  if (value?.ventilasjon) {
    return VarmepumpeFordeling.Ventilasjon;
  }
  return undefined;
};

export const updatedVarmefordeling = (
  val: VarmepumpeFordeling
): Pick<OppvarmingVarmepumpe, 'vannbarenVarme' | 'punktoppvarming' | 'ventilasjon'> => {
  // Apply empty values to the selected varmefordeling
  if (val === VarmepumpeFordeling.Punktoppvarming) {
    return {
      punktoppvarming: {
        serviceGjennomfortSiste2Ar: JaNeiVetIkke.VetIkke
      },
      vannbarenVarme: undefined,
      ventilasjon: undefined
    };
  }

  if (val === VarmepumpeFordeling.VannbarenVarme) {
    return {
      punktoppvarming: undefined,
      vannbarenVarme: {
        bruk: OppvarmingBruk.Ukjent,
        serviceGjennomfortSiste2Ar: JaNeiVetIkke.VetIkke
      },
      ventilasjon: undefined
    };
  }

  if (val === VarmepumpeFordeling.Ventilasjon) {
    return {
      punktoppvarming: undefined,
      vannbarenVarme: undefined,
      ventilasjon: {
        varmesentral: Termostatstyring.Ukjent,
        bruk: OppvarmingBruk.Ukjent,
        serviceGjennomfortSiste2Ar: JaNeiVetIkke.VetIkke
      }
    };
  }
  return {
    punktoppvarming: undefined,
    vannbarenVarme: undefined,
    ventilasjon: undefined
  };
};
